import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { standardColours, visuallyHidden } from '../styles';
import { Svg } from './ui';
import searchIcon from '../images/search-icon.inline.svg';

const StyledSearchForm = styled.form`
  position: relative;
  border-radius: 90px;
  background-color: ${standardColours.lightGrey};
  overflow: hidden;
`;

const StyledLabel = styled.label`
  display: block;

  span {
    ${visuallyHidden()}
  }
`;

const StyledInput = styled.input`
  background: none;
  border: none;
  padding: 0 20px;
  color: ${standardColours.black};
  width: 100%;
  height: 45px;
  border-radius: 90px;

  &::-webkit-search-cancel-button {
    display: none;
  }

  &::placeholder {
    color: ${standardColours.black};
  }
`;

const StyledButton = styled.button`
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  background: none;
`;

const StyledIcon = styled(Svg)`
  width: 20px;
  height: 20px;

  path {
    fill: ${standardColours.black};
  }
`;

const SearchForm = ({ placeholder, displaySearch, ...props }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (displaySearch) {
      inputRef.current?.focus();
    } else {
      inputRef.current?.blur();
    }
  }, [displaySearch]);

  return (
    <StyledSearchForm {...props} action={`/search`}>
      <StyledLabel>
        <span>Search</span>
        <StyledInput
          ref={inputRef}
          type="search"
          name="term"
          placeholder={placeholder}
        />
      </StyledLabel>
      <StyledButton aria-label="Submit Search">
        <StyledIcon image={searchIcon} />
      </StyledButton>
    </StyledSearchForm>
  );
};

export default SearchForm;
